import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const stat = ".stat-number";

function animateStatNumbers() {
  document.querySelectorAll(stat).forEach((el) => {
    const targetStr = el.getAttribute("data-target");
    if (!targetStr) return;

    // Detect formatting
    const hasPound = targetStr.includes("£");
    const isPercent = targetStr.includes("%");
    const isPlus = targetStr.includes("+");
    const isMillion = targetStr.toLowerCase().includes("m");

    // Extract numeric part
    const numberMatch = targetStr.match(/[\d.,]+/);
    if (!numberMatch) return;

    const rawNumeric = numberMatch[0].replace(/,/g, "");
    const numericValue = parseFloat(rawNumeric);
    if (isNaN(numericValue)) return;

    // Determine decimal places
    const decimalPlaces = rawNumeric.includes(".")
      ? rawNumeric.split(".")[1].length
      : 0;

    gsap.fromTo(
      el,
      { innerText: 0 },
      {
        innerText: numericValue,
        duration: 2,
        ease: "power1.out",
        snap: { innerText: 1 },
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          once: true,
        },
        onUpdate: function () {
          let value = parseFloat(el.innerText).toFixed(decimalPlaces);
          value = Number(value).toLocaleString();

          el.innerText = "";
          if (hasPound) el.innerText += "£";
          el.innerText += value;
          if (isMillion) el.innerText += "m";
          if (isPercent) el.innerText += "%";
          if (isPlus) el.innerText += "+";
        },
      }
    );
  });
}
if (stat) {
  animateStatNumbers();
}
